module.exports = __webpack_public_path__ + "img/check-green.40687024.svg";